module.exports = __webpack_public_path__ + "a1cbe7addfce18f9331ccbf9a5a7c614.svg";